<template>
  <component :is="tag" template-tag="page-content-center" class="page-content-center w-full lg:w-360  max-lg:px-2rem max-ml:px-1rem mx-auto">
    <slot></slot>
  </component>
</template>
<script setup lang="ts">
interface Props {
  tag?: string
}

withDefaults(defineProps < Props > (), {
  tag: 'div',
})
</script>
